import BackendService from './BackendService';

async function getCashboxOpeningReports(data = {}, params = {}) {
  return BackendService.getData('/manual-cashbox-openings/report/', {}, { ...data, ...params });
}

const CashboxReportService = {
  getCashboxOpeningReports,
};

export default CashboxReportService;
